var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhislistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6041 2.19264C13.1822 1.54107 13.8851 1.01197 14.6711 0.6366C15.4572 0.261227 16.3105 0.0471911 17.1806 0.00713714C18.0508 -0.0329168 18.9201 0.101823 19.7373 0.403398C20.5545 0.704973 21.303 1.16727 21.9385 1.76297C22.5741 2.35867 23.0838 3.0757 23.4375 3.8717C23.7913 4.6677 23.982 5.52653 23.9982 6.39745C24.0145 7.26837 23.8561 8.13372 23.5323 8.94238C23.2085 9.75104 22.726 10.4866 22.1131 11.1056L12.5331 20.7776C12.4634 20.8481 12.3804 20.904 12.2889 20.9422C12.1974 20.9803 12.0992 21 12.0001 21C11.901 21 11.8028 20.9803 11.7114 20.9422C11.6199 20.904 11.5369 20.8481 11.4671 20.7776L1.88712 11.1056C0.725108 9.93247 0.0516695 8.362 0.00285185 6.71148C-0.0459658 5.06096 0.533477 3.45343 1.62412 2.21364C4.21212 -0.72936 8.79412 -0.73936 11.3961 2.19264L12.0001 2.87264L12.6041 2.19264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhislistIcon);
export default __webpack_public_path__ + "static/media/whislistIcon.ac937050da3b86abf1c5ef32465ecd4a.svg";
export { ForwardRef as ReactComponent };